import { useNavigate } from "react-router-dom";

import { NOTIFICATIONS } from "@const/notifications";
import { URLS } from "@const/urls";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

/**
 * 세션이 만료됐을 때의 공통 처리. 고객 조회(useCustomer)와 카트 생성(useCart) 양쪽에서 쓴다.
 *
 * 카트 쪽이 중요한데, buyerIdentity 에 넘긴 토큰이 무효라고 응답오면 로그아웃까지 해야 한다.
 * customer 만 남고 카트에는 buyerIdentity 가 없는 상태가 되면 App 의 불일치 검사가 풀리지 않는다.
 */
export default function useSessionExpired() {
  const navigate = useNavigate();

  const { logout } = useCustomerStore();
  const { openToast, openAccount } = useLayoutStore();

  return () => {
    openToast(NOTIFICATIONS.WARNING_END_SESSION);
    logout();
    navigate(URLS.HOME);
    setTimeout(() => {
      openAccount(true);
    }, 300);
  };
}
